import type { MouseEventHandler } from "react";

import { IconButton } from "../../../_core/IconButton/IconButton.emotion";
import { ShareIcon } from "../../../icons/Icon/GeneralIcons";
import type { DailyQuoteProps } from "../../other/DailyQuote/DailyQuote.emotion";
import type { BaseGetSectionItemProps } from "./Section.emotion";

export type GetSectionItemDailyQuotePropsProps = BaseGetSectionItemProps & {
  onShare: MouseEventHandler;
};

export const getSectionItemDailyQuoteProps = ({
  item,
  onShare,
}: GetSectionItemDailyQuotePropsProps): DailyQuoteProps => ({
  attribution: item?.reference?.attributed_to,
  quote: item?.reference?.text,
  actions: [
    <IconButton
      key="daily-quote-share"
      icon={<ShareIcon />}
      variant={"secondary"}
      onClick={onShare}
    />,
  ],
});
